/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Dealinformation1Inputs */

const en_common_dealinformation1 = /** @type {(inputs: Common_Dealinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal Information`)
};

/**
* | output |
* | --- |
* | "Deal Information" |
*
* @param {Common_Dealinformation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_dealinformation1 = /** @type {((inputs?: Common_Dealinformation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Dealinformation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_dealinformation1(inputs)
});
export { common_dealinformation1 as "common_dealInformation" }